import { authHeader } from "../util/auth-header";
import http from "../util/http-common";

export class ExcludedErrorVinService {
    static async getAllExcludedError() {
        return http.get("/cfadminvinadmin/api/v1/exclude-error-vin",{ headers: await authHeader()});
    }

    static async createExcludedError(data: any) {
        return http.post("/cfadminvinadmin/api/v1/exclude-error-vin", data, { headers: await authHeader()});
    }

    static async updateExcludedError(id: number, data: any) { //id to pass
        return http.put(`/cfadminvinadmin/api/v1/exclude-error-vin/${id}`, data, { headers: await authHeader()});
    }

    static async deleteExcludedError(id: any) {
        return http.delete(`/cfadminvinadmin/api/v1/exclude-error-vin/${id}`,{ headers: await authHeader()});
    }

}

export default ExcludedErrorVinService;